<div class="container-component">
  @if (isLoad) {
    <app-header></app-header>
  }
  <div>
    <router-outlet></router-outlet>
  </div>

  <div
    class="progress-spinner"
    style="z-index: 10005"
    *ngIf="notificationService.isLoading$ | async"
  >
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-toast></p-toast>
</div>
